'use client';
import React from 'react'
import useCustomSWR from '@/hook/useCustomSWR'
import { Skeleton } from '@mui/material'
import Card from '@/components/product/Card'
import { v4 as uuidv4 } from 'uuid'
import Pagination from '@/app/blog/components/Pagination';
const AwardProducts = ({ id, page }) => {
    const currentPage = page ? page : 1
    const ids = [id]
    const { data, error, isLoading } = useCustomSWR(`/v1/products/get-all-products?page=${currentPage}&limit=8&filter[awards][$in]=${encodeURIComponent(JSON.stringify(ids))}`, true)
    if (!data?.productList) return null
    const products = data?.productList;
    return (
        <>
            <div className='mt-2 grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-5 xl:grid-cols-4'>
                {isLoading &&
                    Array.from({ length: 12 }, (_, index) => (
                        <div key={uuidv4()} className='h-52 w-full overflow-hidden rounded-lg md:h-96 2xl:h-[30rem]'>
                            <Skeleton
                                animation='wave'
                                variant='rectangular'
                                width='100%'
                                height='100%'
                            />
                        </div>
                    ))}
                {products?.length !== 0 ?
                    products?.map((product) => (
                        <Card key={uuidv4()} product={product} />
                    )) : (
                        <div className='h-40 flex justify-center items-center col-span-2 md:col-span-3  xl:col-span-4'>
                            <p className='text-xl md:text-2xl font-medium text-center '>Product line concluded. Gratitude.</p>
                        </div>
                    )
                }
            </div>
            {
                data?.totalPages > 1 && (
                    <div className='p-5 flex justify-center items-center'>
                        <Pagination totalPage={data?.totalPages} />
                    </div>
                )
            }
        </>
    )
}

export default AwardProducts